import React, {useEffect, useState} from 'react';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {Usuario} from './Usuario';
import {ListaUsu} from './ListaUsu';
import {FormularioUsuarios} from './FormularioUsuarios';
import Switch from 'react-switch';

export const ContentBodyUsuarios = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;

	/* A hook that is used to store the state of the component. */
	const [ListaUsuarios, setListaUsuarios] = useState(ListaUsu());

	/* A hook that is used to store the state of the component. */
	const [PantallaPeril, setPantallaPerfil] = useState(false);

	/* A hook that is used to store the state of the component. */
	const [UsuarioFiltro, setUsuarioFiltro] = useState({
		nombre: '',
		telefono: '',
		ID: '',
	});

	/**
	 * When the input changes, set the UsuarioFiltro state to the current value of the input.
	 */
	const onInputChange = (event) => {
		setUsuarioFiltro({
			...UsuarioFiltro,
			[event.target.name]: event.target.value,
		});
	};

	/* A hook that is used to store the state of the component. */
	useEffect(() => {
		setListaUsuarios(ListaUsu());
	}, []);

	/**
	 * It sets the state of pantallaPerfil to true.
	 */
	const abrirPerfil = () => {
		setPantallaPerfil(true);
	};

	/**
	 * It sets the state of pantallaPerfil to true.
	 */
	const anadirUsuarios = () => {
		setPantallaPerfil(true);
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={5}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentUsuarios'>
				{PantallaPeril === false ? (
					<div className='derContentUsusaios'>
						<div className='headContentUsuarios'>
							<div className='superiorHeadContentUsuarios'>
								<div>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='40'
										height='40'
										fill='currentColor'
										className='bi bi-person-lines-fill'
										viewBox='0 0 16 16'
									>
										<path d='M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z' />
									</svg>
								</div>
								<div className='centrador titleHeadHistorialFacturas'>Usuarios</div>
							</div>
							<div className='separador'></div>
							<div className='inferiorHeadContentUsuarios'>
								<div className='derHeadContentUsuarios'>
									<div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>Nombre</div>
										<div className='inputUsuario'>
											<input
												className='inputTextUsuario'
												name='nombre'
												type='text'
												value={UsuarioFiltro.nombre}
												onChange={onInputChange}
											/>
										</div>
									</div>
									<div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>Teléfono</div>
										<div className='inputUsuario'>
											<input
												className='inputTextUsuario'
												name='telefono'
												type='text'
												value={UsuarioFiltro.telefono}
												onChange={onInputChange}
											/>
										</div>
									</div>
									<div className='inputHeadContentUsuarios'>
										<div className='labelInputUsuarios'>ID</div>
										<div className='inputUsuario'>
											<input
												className='inputTextUsuario'
												name='ID'
												type='text'
												value={UsuarioFiltro.ID}
												onChange={onInputChange}
											/>
										</div>
									</div>
								</div>
								<div className='izqheadContentUsuarios centrador'>
									<div
										className='buttonAddUsuarios'
										onClick={anadirUsuarios}
									>
										<div className='centrador'>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='16'
												height='16'
												fill='currentColor'
												className='bi bi-plus-circle-fill'
												viewBox='0 0 16 16'
											>
												<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
											</svg>
										</div>
										<div className='centrador'>Añadir Usuario</div>
									</div>
								</div>
							</div>
						</div>
						<div className='listaPaciente'>
							{ListaUsuarios.map((usuario, id) =>
								usuario.nombreUsuario
									.toLowerCase()
									.includes(UsuarioFiltro.nombre.toLowerCase()) &&
								(usuario.telefonoUsuario.includes(UsuarioFiltro.telefono) ||
									usuario.telefonoUsuario2.includes(UsuarioFiltro.telefono)) &&
								usuario.idUsuario.includes(UsuarioFiltro.ID) ? (
									<Usuario
										key={id}
										fotPantallaPerileccionUsuario={usuario.direccionUsuario}
										nombreUsuario={usuario.nombreUsuario}
										idUsuario={usuario.idUsuario}
										nombreUsu={usuario.nombreUsu}
										telefonoUsuario={usuario.telefonoUsuario}
										correoUsuario={usuario.correoUsuario}
										telefonoUsuario2={usuario.telefonoUsuario2}
										abrirPerfil={abrirPerfil}
									/>
								) : null
							)}
						</div>
					</div>
				) : (
					<FormularioUsuarios setPantallaPerfil={setPantallaPerfil} />
				)}
			</div>
		</>
	);
};
/*
usuarios:
    info tarjetas:
        - nombre correo telefono 
    form :
        - contrase correo ... ( lo que hay en mi perfil )

pacientes:
    info tarjeta: 
        - nombre y apellidos
        - direcion
        - localicadad
        - cod postal
        - telefono corroceo
        - sharecare
    form:
        - numero cuenta
cuidadore: 
    info:
        - nombre, apellido localidad, telfono, estado si esta trabajando   
    form :
        - ratio
*/
